import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { getCsrfToken } from '../../api/GET/csrftoken'

export const useQueryCsrfToken = () => {
  const navigate = useNavigate()

  return useQuery({
    queryKey: 'csrfToken',
    queryFn: () => getCsrfToken(),
    staleTime: 0,
    onError: () => navigate('/login'),
  })
}
